import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Mail, Phone, ArrowRight } from "lucide-react";
import { CLAIM } from "@/constants/testIds";
import { COMPANY } from "@/lib/company";
import Seo from "@/components/Seo";

export default function ThankYou() {
    const [params] = useSearchParams();
    const ref = params.get("ref");

    return (
        <section data-testid={CLAIM.successScreen} className="bg-slate-50 min-h-[calc(100vh-5rem)]">
            <Seo title="Claim received" description="Thanks for submitting your claim with ClaimHub UK." path="/thank-you" noIndex />
            <div className="container-x py-16 lg:py-24">
                <div className="max-w-2xl mx-auto text-center">
                    <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-emerald-100 border border-emerald-200 mb-6">
                        <CheckCircle2 className="w-10 h-10 text-emerald-600" />
                    </div>
                    <h1 className="text-4xl sm:text-5xl font-display font-bold tracking-tight text-navy-900">
                        We&apos;ve got it.
                    </h1>
                    <p className="mt-5 text-lg text-slate-600 leading-relaxed">
                        Your claim is now in the queue. A specialist will review the details and be in touch within one working day with the next steps.
                    </p>

                    {ref && (
                        <div className="mt-9 inline-block bg-white border border-slate-200 rounded-2xl px-7 py-5">
                            <div className="text-xs font-semibold uppercase tracking-[0.18em] text-emerald-700">Your reference</div>
                            <div data-testid={CLAIM.successReference} className="mt-1 font-mono text-2xl font-bold text-navy-900 tracking-wide">
                                {ref}
                            </div>
                        </div>
                    )}

                    <div className="mt-10 grid sm:grid-cols-2 gap-4 text-left">
                        <div className="card-soft p-6">
                            <Phone className="w-5 h-5 text-emerald-600" />
                            <div className="mt-3 font-semibold text-navy-900">Speak to us today</div>
                            <div className="mt-1 text-sm text-slate-500">{COMPANY.hours}.</div>
                            <a href={`tel:${COMPANY.phoneTel}`} className="mt-3 inline-block font-display font-bold text-xl text-navy-900">{COMPANY.phone}</a>
                        </div>
                        <div className="card-soft p-6">
                            <Mail className="w-5 h-5 text-emerald-600" />
                            <div className="mt-3 font-semibold text-navy-900">Prefer email?</div>
                            <div className="mt-1 text-sm text-slate-500">We reply within one working day.</div>
                            <a href={`mailto:${COMPANY.email}`} className="mt-3 inline-block font-display font-semibold text-base text-emerald-700">{COMPANY.email}</a>
                        </div>
                    </div>

                    <div className="mt-12 flex flex-wrap justify-center gap-3">
                        <Link to="/" className="btn-secondary">Back to home</Link>
                        <Link to="/how-it-works" className="btn-primary">What happens next <ArrowRight className="w-4 h-4" /></Link>
                    </div>
                </div>
            </div>
        </section>
    );
}
